var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "elevation-12" } },
            [
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "v-container",
                {
                  staticClass: "animated fadeIn fast",
                  attrs: { fluid: "", "fill-height": "", "grid-list-md": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "", "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm8: "", md5: "" } },
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-text", [
                                _c(
                                  "div",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "25px" }
                                        },
                                        [_vm._v("Cambio de Contraseña")]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c("br")
                              ]),
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticStyle: { padding: "0px 20px 20px" },
                                  attrs: {
                                    "lazy-validation": "",
                                    align: "center"
                                  },
                                  model: {
                                    value: _vm.validFormActualizaPass,
                                    callback: function($$v) {
                                      _vm.validFormActualizaPass = $$v
                                    },
                                    expression: "validFormActualizaPass"
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      xs3: "",
                                      md3: "",
                                      lg3: "",
                                      autocomplete: "false",
                                      readonly: "",
                                      onfocus:
                                        "this.removeAttribute('readonly');",
                                      "prepend-icon": "lock_open",
                                      "append-icon": _vm.show2
                                        ? "visibility_off"
                                        : "visibility",
                                      label: "Contraseña Actual",
                                      type: _vm.show2 ? "text" : "password",
                                      rules: _vm.passRules1,
                                      counter: 20,
                                      required: ""
                                    },
                                    on: {
                                      "click:append": function($event) {
                                        _vm.show2 = !_vm.show2
                                      }
                                    },
                                    model: {
                                      value: _vm.userDataChangePass.contrasena1,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userDataChangePass,
                                          "contrasena1",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "userDataChangePass.contrasena1"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|max:20|min:8",
                                        expression: "'required|max:20|min:8'"
                                      }
                                    ],
                                    attrs: {
                                      "prepend-icon": "lock_open",
                                      autocomplete: "new-password",
                                      readonly: "",
                                      onfocus:
                                        "this.removeAttribute('readonly');",
                                      "append-icon": _vm.show3
                                        ? "visibility_off"
                                        : "visibility",
                                      label: "Nueva Contraseña",
                                      type: _vm.show3 ? "text" : "password",
                                      rules: _vm.passRules2,
                                      counter: 20,
                                      required: ""
                                    },
                                    on: {
                                      "click:append": function($event) {
                                        _vm.show3 = !_vm.show3
                                      },
                                      keyup: function($event) {
                                        return _vm.changeInput()
                                      }
                                    },
                                    model: {
                                      value: _vm.userDataChangePass.contrasena2,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userDataChangePass,
                                          "contrasena2",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "userDataChangePass.contrasena2"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    attrs: {
                                      "prepend-icon": "lock_open",
                                      autocomplete: "new-password",
                                      readonly: "",
                                      onfocus:
                                        "this.removeAttribute('readonly');",
                                      "append-icon": _vm.show4
                                        ? "visibility_off"
                                        : "visibility",
                                      "data-vv-name": "contrasena3",
                                      label: "Repita Contraseña",
                                      type: _vm.show4 ? "text" : "password",
                                      rules: _vm.passRules3,
                                      counter: 20,
                                      required: ""
                                    },
                                    on: {
                                      "click:append": function($event) {
                                        _vm.show4 = !_vm.show4
                                      },
                                      keyup: function($event) {
                                        return _vm.changeInput()
                                      }
                                    },
                                    model: {
                                      value: _vm.userDataChangePass.contrasena3,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userDataChangePass,
                                          "contrasena3",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "userDataChangePass.contrasena3"
                                    }
                                  }),
                                  _c("br"),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c("v-flex", [
                                            _c(
                                              "div",
                                              { attrs: { align: "right" } },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      type: "button",
                                                      id: "btnAceptar",
                                                      color: "#526da5",
                                                      disabled: !_vm.validFormActualizaPass
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.actualizarPassLogin()
                                                      },
                                                      keyup: function($event) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        ) {
                                                          return null
                                                        }
                                                        return _vm.actualizarPassLogin()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "white"
                                                        }
                                                      },
                                                      [_vm._v("Aceptar")]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c("br"),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("br"),
                                              _c(
                                                "v-layout",
                                                [
                                                  _c("v-divider"),
                                                  _c(
                                                    "v-expansion-panel",
                                                    [
                                                      _c(
                                                        "v-expansion-panel-content",
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "12px"
                                                              },
                                                              attrs: {
                                                                slot: "header"
                                                              },
                                                              slot: "header"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              Reglas de contraseña\n                            "
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-card",
                                                            [
                                                              _c(
                                                                "v-card-text",
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle: {
                                                                        "font-size":
                                                                          "12px"
                                                                      },
                                                                      attrs: {
                                                                        align:
                                                                          "left"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                  * Debe tener un largo mínimo de 8\n                                  caracteres.\n                                "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c("br"),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle: {
                                                                        "font-size":
                                                                          "12px"
                                                                      },
                                                                      attrs: {
                                                                        align:
                                                                          "left"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                  * Debe tener un largo máximo de 20\n                                  caracteres.\n                                "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c("br"),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle: {
                                                                        "font-size":
                                                                          "12px"
                                                                      },
                                                                      attrs: {
                                                                        align:
                                                                          "left"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                  * Debe contener al menos una mayúscula\n                                  ('A'-'Z').\n                                "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c("br"),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle: {
                                                                        "font-size":
                                                                          "12px"
                                                                      },
                                                                      attrs: {
                                                                        align:
                                                                          "left"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                  * Debe contener al menos una minúscula\n                                  ('a'-'z').\n                                "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c("br"),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle: {
                                                                        "font-size":
                                                                          "12px"
                                                                      },
                                                                      attrs: {
                                                                        align:
                                                                          "left"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                  * Debe contener al menos un número\n                                  ('0'-'9').\n                                "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c("br"),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle: {
                                                                        "font-size":
                                                                          "12px"
                                                                      },
                                                                      attrs: {
                                                                        align:
                                                                          "left"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "* Debe contener al menos un símbolo [. , #\n                                  @ - _]."
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c("br"),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle: {
                                                                        "font-size":
                                                                          "12px"
                                                                      },
                                                                      attrs: {
                                                                        align:
                                                                          "left"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                  * Debe ser una contraseña no utilizada con\n                                  anterioridad.\n                                "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("br"),
                                      _c("br")
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.primerIngreso,
                          expression: "primerIngreso"
                        }
                      ],
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogConfirmacionClose = true
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Cambiar Contraseña")]),
                  _c("v-spacer")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-xs-center" },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "480" },
              model: {
                value: _vm.modalLogout,
                callback: function($$v) {
                  _vm.modalLogout = $$v
                },
                expression: "modalLogout"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticStyle: {
                            "font-size": "17px",
                            "margin-left": "10px !important"
                          }
                        },
                        [_vm._v("Cambio de Contraseña")]
                      )
                    ],
                    1
                  ),
                  _c("v-card-text", [
                    _vm._v(
                      "\n          La Contraseña ha sido actualizada de forma exitosa. Su sesión se\n          cerrará\n        "
                    )
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.ejecutaLogout()
                            }
                          }
                        },
                        [_vm._v("Aceptar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "380" },
          model: {
            value: _vm.dialogConfirmacionClose,
            callback: function($$v) {
              _vm.dialogConfirmacionClose = $$v
            },
            expression: "dialogConfirmacionClose"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "font-size": "17px",
                        "margin-left": "10px !important"
                      }
                    },
                    [_vm._v("\n          Confirmación\n        ")]
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "div",
                { attrs: { id: "alinear" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _vm._v(
                        "\n          ¿Está seguro que desea cerrar sin cambiar la contraseña?\n          "
                      ),
                      _c("br"),
                      _c("v-checkbox", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.primerIngreso,
                            expression: "!primerIngreso"
                          }
                        ],
                        attrs: {
                          label: "No volver a solicitar cambio de contraseña "
                        },
                        model: {
                          value: _vm.confirmacionAdicional,
                          callback: function($$v) {
                            _vm.confirmacionAdicional = $$v
                          },
                          expression: "confirmacionAdicional"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        "data-testid": "v-btn--cancelar",
                        color: "white",
                        depressed: "",
                        small: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.confirmCallbackConfirm(false)
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "#526da5" } }, [
                        _vm._v("Cancelar")
                      ])
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        "data-testid": "v-btn--aceptar",
                        color: "#526da5",
                        depressed: "",
                        small: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.confirmCallbackConfirm(true)
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "white" } }, [
                        _vm._v("Confirmar")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }